<template>
    <div class="col-sm-12 nopads">
        <div class="search-form px-3">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search"/>
                {{ $t('common.search') }}
            </div>
            <form
                class="no-margin"
                @submit.prevent="onSubmit"
                @reset.prevent="onReset"
            >
                <div class="row nopads">
                    <div class="col-sm-6 px-2">
                        <span class="search-title">
                          {{ $t('ins_report.from_date') }}
                        </span>
                        <date-time-picker
                            class="routa-input"
                            v-model:date="fromDate"
                            format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true"
                            :placeholder="$t('observations_videos.search_input_format')"
                        />
                    </div>

                    <div class="col-sm-6 px-2">
                        <span class="search-title">
                          {{ $t('ins_report.to_date') }}
                        </span>
                        <date-time-picker
                            class="routa-input"
                            v-model:date="toDate"
                            format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true"
                            :placeholder="$t('observations_videos.search_input_format')"
                        />
                    </div>
                </div>
                <div class="row nopads">
                        <area-filter
                            ref="areaFilter"
                            :is-admin="false"
                            :no-geom="true"
                            :multiple="true"
                            @areaSet="setArea"
                            @areasSet="setAreas"
                        />
                </div>
                <div class="row nopads">
                    <div class="col-sm-6 nopads ml-1 pr-2">
                        <open-contract-filter-multi-select
                            :to="toDate"
                            :from="fromDate"
                            :show-company="false"
                            :no-pads="true"
                            :show-only-my-contracts-option="true"
                            @loading="loading=true"
                            @loadingCompleted="loading=false"
                            @contractsSelected="setContracts"
                        />
                    </div>
                </div>
                <div class="col-sm-12 button-container">
                    <button
                        type="submit"
                        class="form-button btn btn-primary"
                    >
                        {{ $t('ins_report.search') }}
                    </button>
                </div>
            </form>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import AreaFilter from '../AreaFilter'
import {timeUtils} from "../../mixins/TimeUtils";
import OpenContractFilterMultiSelect from "@/components/contract/OpenContractFilterMultiSelect.vue";
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'AreaWorkFilter',
    components: {
        OpenContractFilterMultiSelect,
        AreaFilter,
        DateTimePicker
    },
    mixins: [restApi, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            name: null,
            area: null,
            areas: [],
            contract: null,
            contracts: [],
            fromDate: null,
            toDate: null
        }
    },

    mounted: function () {
        if (!this.fromDate) {
            this.fromDate = this.getMonthStart()
        }
    },

    methods: {
        onReset: function () {
            this.name = null
            this.area = null
            this.areas = []
            this.company = null
            this.contract = null
            this.contracts = []
            this.$refs.areaFilter.resetData()
        },
        onSubmit: function () {
            var params = {}
            if (this.area) {
                params.area = this.area.id
            }
            if(this.areas && this.areas.length > 0) {
                params.areas = this.areas.map(item => item.id)
            }
            params.from = this.fromDate
            if (this.toDate) {
                params.to = this.toDate
            }
            if(this.contracts && this.contracts.length > 0) {
                params.contractIds = this.contracts.map(item => item.id)
            }
            this.$emit('search', params)
        },

        setArea: function (area) {
            this.area = area
        },

        setAreas: function (areas) {
            this.areas = areas
        },

        setContract: function (contract) {
            this.contract = contract ? contract.id : null
        },

        setContracts: function (contracts) {
            this.contracts = contracts
        },

    }
}
</script>

<style scoped>

</style>
